import { sanitizeFilename } from './sanitizeFilename';
import { parseContentDispositionParameters } from './parseContentDispositionParameters';
import { parseContentDispositionParametersNonstandard } from './parseContentDispositionParametersNonstandard';
import { decodeFilename } from './decodeFilename';

export function getFilenameFromContentDisposition(
    contentDisposition?: string | null,
    { supportNonstandardHeaders } = { supportNonstandardHeaders: true },
): string | undefined {
    if (!contentDisposition) {
        return undefined;
    }

    const parse = supportNonstandardHeaders
        ? parseContentDispositionParametersNonstandard
        : parseContentDispositionParameters;

    const parameters = parse(contentDisposition);

    const filename = parameters['filename*'] ?? parameters.filename;

    if (!filename) {
        return undefined;
    }

    return sanitizeFilename(decodeFilename(filename));
}
